module.exports = __webpack_public_path__ + "static/media/medanta.d03b3918.webp";